(() => {
  const setup = (slider) => {
    if (!slider || slider.dataset.tickerPositionInitialized === 'true') return;

    const heroSection = slider.closest('.shopify-section');
    const tickerSection = heroSection?.nextElementSibling;
    const ticker = tickerSection?.querySelector('[data-section-type="scrolling-content"]');
    if (!heroSection || !ticker) return;

    let frame;
    const positionTicker = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const heroTop = Math.max(0, heroSection.getBoundingClientRect().top + window.scrollY);
        const tickerHeight = tickerSection.getBoundingClientRect().height;
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const heroHeight = Math.max(280, viewportHeight - heroTop - tickerHeight);

        slider.style.setProperty('--pb-opening-hero-height', `${heroHeight}px`);
        slider.classList.add('campaign-slider--opening-height');
      });
    };

    const resizeObserver = new ResizeObserver(positionTicker);
    resizeObserver.observe(tickerSection);
    window.addEventListener('resize', positionTicker, { passive: true });
    window.visualViewport?.addEventListener('resize', positionTicker, { passive: true });

    slider.dataset.tickerPositionInitialized = 'true';
    positionTicker();
  };

  const setupAll = (container = document) => {
    container.querySelectorAll('[data-custom-hero-slider]').forEach(setup);
  };

  setupAll();
  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
